import React, { useContext, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Table, Tag } from 'antd';
import { SorterResult, TablePaginationConfig } from 'antd/lib/table/interface';
import { sortOrderType } from 'common/utils';
import { rootContext } from 'stores';
import { ILoginActivity, ITransactionInfo, ItransactionType } from 'types';
import './index.scss';
import dayjs from 'dayjs';
import calendar from 'dayjs/plugin/calendar';
dayjs.extend(calendar)

export type UsertransactiontableProps = {
  id: string;
};
const UserLoginHistoryTable: React.FC<UsertransactiontableProps> = observer(
  ({ id }) => {
    const {
      UsersStore: {
        getUserLoginActivity,
        setState,
        state: {
          data: { userDetail, userLoginActivityParams },
          data,
          ui: { getLoginActivity }
        }
      }
    } = useContext(rootContext);
    const { limit, offset } = userLoginActivityParams;

    useEffect(() => {
      getUserLoginActivity({ userId: id, ...userLoginActivityParams });
    }, [getUserLoginActivity, id, setState, userLoginActivityParams]);

    const onChange = (pagination: any, _: any, sort: any) => {
      const sortInfo = sort as SorterResult<ITransactionInfo>;

      setState({
        data: {
          ...data,
          userLoginActivityParams: {
            ...userLoginActivityParams,
            limit: pagination.pageSize || userLoginActivityParams.limit,
            offset: ((pagination.current || 1) - 1) * pagination.pageSize,
            ...(sortInfo?.columnKey ? { sortField: sortInfo.columnKey } : {}),
            sortBy: sortInfo?.order ? sortOrderType(sortInfo.order) : null
          }
        }
      });
    };

    return (
      <Table<ILoginActivity>
        rowKey="id"
        loading={getLoginActivity}
        title={() => 'Account Activity'}
        className="Table_block_main"
        dataSource={userDetail.login_activity || []}
        pagination={{
          current: Number((offset / limit).toFixed(0)) + 1,
          pageSize: limit,
          total: userDetail.login_activity_total_count,
          showSizeChanger: true,
          pageSizeOptions: ['10', '15', '20']
        }}
        onChange={onChange}
        columns={[
          {
            title: 'Login Time',
            dataIndex: 'createdAt',
            key: 'createdAt',
            render: date => dayjs(date).calendar(),
            align: 'center',
            sorter: true
          },
          {
            title: 'User IP Address',
            dataIndex: 'ip_address',
            key: 'ip_address',
            align: 'center'
          },
          {
            title: 'Browser',
            dataIndex: 'browser',
            key: 'browser',
            align: 'center'
          },
          {
            title: 'Version',
            dataIndex: 'version',
            key: 'version',
            align: 'center',
            sorter: true
          },
          {
            title: 'OS',
            dataIndex: 'os',
            key: 'os',
            align: 'center'
          },
          {
            title: 'Platform',
            dataIndex: 'platform',
            key: 'platform',
            align: 'center'
          },
          {
            title: '2FA Triggered',
            dataIndex: 'two_factor_request',
            key: 'two_factor_request',
            align: 'center',
            render: data => {
              return (
                <Tag color={data ? 'red' : 'green'}>{data ? 'YES' : 'NO'}</Tag>
              );
            }
          }
        ]}
      />
    );
  }
);

export default UserLoginHistoryTable;
